import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const PaymentSuccess = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Show success message
    const message = searchParams.get("message") || t("payment_successful");
    toast.success(message);

    // Redirect to login after 2 seconds
    const timer = setTimeout(() => {
      navigate("/login");
    }, 2000);

    return () => clearTimeout(timer);
  }, [navigate, searchParams, t]);

  return (
    <SuccessWrapper>
      <div className="success-container">
        <div className="success-icon">✓</div>
        <h1>{t("payment_successful")}</h1>
        <p>{t("your_account_has_been_activated")}</p>
        <p className="redirect-text">
          {t("redirecting_to_login")}...
        </p>
      </div>
    </SuccessWrapper>
  );
};

export default PaymentSuccess;

const SuccessWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);

  .success-container {
    text-align: center;
    background: white;
    padding: 60px 40px;
    border-radius: 10px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
    max-width: 500px;
    width: 90%;
  }

  .success-icon {
    font-size: 80px;
    color: #4caf50;
    margin-bottom: 20px;
    animation: bounce 0.6s ease-in-out;
  }

  h1 {
    color: #333;
    margin-bottom: 15px;
    font-size: 28px;
  }

  p {
    color: #666;
    font-size: 16px;
    line-height: 1.6;
    margin: 10px 0;
  }

  .redirect-text {
    color: #999;
    font-size: 14px;
    margin-top: 20px;
  }

  @keyframes bounce {
    0%,
    100% {
      transform: scale(0.5);
      opacity: 0;
    }
    50% {
      transform: scale(1.2);
      opacity: 1;
    }
  }

  @media (max-width: 600px) {
    .success-container {
      padding: 40px 20px;
    }

    h1 {
      font-size: 24px;
    }

    p {
      font-size: 14px;
    }

    .success-icon {
      font-size: 60px;
    }
  }
`;
